import React, { useEffect } from "react";
import "./DataAnalysis.css";
import analysisImg from "../../assets/images/data-analysis.png"; // ⭐ apni image yaha add karein

const DataAnalysis = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".reveal-app");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-app");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((sec) => observer.observe(sec));
  }, []);

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="app-hero-section reveal-app">
        <div className="app-hero-container">
          
          {/* LEFT TEXT */}
          <div className="app-hero-text reveal-app">
            <h1>Data Analysis</h1>

            <p>
              At NMD Info Tech Services, we know that smart decisions start with
              the right insights. That’s why we’re thrilled to introduce our
              Data Analysis Services—a major leap in our commitment to providing
              you with comprehensive, results-driven solutions.
            </p>

            <p>
              In an era where data fuels every decision, our services are crafted
              to empower your organization with clear, actionable insights and
              strategic foresight. By transforming raw data into a competitive
              edge, we help you not only understand what’s happening in your
              business but also anticipate what’s next.
            </p>

            <p>
              Let’s turn your data into a roadmap for success and drive your
              industry leadership—together.
            </p>

            <button className="app-hero-btn">Get Started</button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="app-hero-image reveal-app">
            <img src={analysisImg} alt="Data Analysis" />
          </div>
        </div>
      </section>

      {/* ================= SECOND SECTION ================= */}
      <section className="app-second-section reveal-app">
  <div className="app-second-container">
    
    {/* LEFT FORM BOX */}
    <div className="app-form-box reveal-app">
      <h2>Get an Appointment</h2>

      <form
        action="https://api.web3forms.com/submit"
        method="POST"
      >
        {/* REQUIRED: WEB3FORMS ACCESS KEY */}
        <input
          type="hidden"
          name="access_key"
          value="157f5dfc-898c-4749-aab8-a80e612db795"
        />

        <input type="text" name="name" placeholder="Name *" required />
        <input type="email" name="email" placeholder="Email *" required />
        <textarea name="message" placeholder="Message Here" rows="5"></textarea>

        <button type="submit" className="app-send-btn">Send</button>
      </form>
    </div>

    {/* RIGHT TEXT CONTENT */}
    <div className="app-second-text reveal-app">
      <h1>Why Data Analysis?</h1>

      <p>
        Data analysis is the secret sauce that transforms everyday data into
        strategic insights. It’s what turns numbers into narratives, enabling
        businesses to uncover hidden trends and drive smart decisions.
      </p>

      <p>
        At NMD Info Tech Services, we believe that every dataset has the
        potential to reveal powerful opportunities. Using advanced techniques
        and industry expertise, we dig deep into your data to uncover
        actionable insights that help you streamline operations, anticipate
        market shifts, and better serve your customers.
      </p>

      <p>
        With our approach, data isn’t just information—it’s about fueling
        innovation and securing a competitive edge. Let’s decode your data
        together and pave the way for smarter, more informed growth.
      </p>
    </div>
  </div>
</section>

      {/* ================= THIRD FEATURE SECTION (Same format) ================= */}
      <section className="app-features-section reveal-app">
        <h2 className="app-feature-title">More Solutions We Offer</h2>

        <div className="scroll-line"></div>

        <div className="app-features-container">

          {/* CARD 1 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">📊</div>
                <h3>Data Visualization</h3>
                <p>
                  Transform raw data into easy-to-understand dashboards and charts.
                </p>
              </div>
              <div className="card-back">
                <h3>Data Visualization</h3>
                <p>
                  Transform raw data into easy-to-understand dashboards and charts.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">📈</div>
                <h3>Predictive Analytics</h3>
                <p>
                  Use future forecasting to make smart and proactive decisions.
                </p>
              </div>
              <div className="card-back">
                <h3>Predictive Analytics</h3>
                <p>
                  Use future forecasting to make smart and proactive decisions.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">🧠</div>
                <h3>AI Data Processing</h3>
                <p>
                  Intelligent models that extract meaningful patterns instantly.
                </p>
              </div>
              <div className="card-back">
                <h3>AI Data Processing</h3>
                <p>
                  Intelligent models that extract meaningful patterns instantly.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 4 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">⚙️</div>
                <h3>Automation Reports</h3>
                <p>
                  Auto-generated reports that save time and increase accuracy.
                </p>
              </div>
              <div className="card-back">
                <h3>Automation Reports</h3>
                <p>
                  Auto-generated reports that save time and increase accuracy.
                </p>
              </div>
            </div>
          </div>

          {/* CARD 5 */}
          <div className="app-feature-card">
            <div className="card-inner">
              <div className="card-front">
                <div className="icon-box">🔍</div>
                <h3>Market Research</h3>
                <p>
                  Deep insights about competition, customers, and future trends.
                </p>
              </div>
              <div className="card-back">
                <h3>Market Research</h3>
                <p>
                  Deep insights about competition, customers, and future trends.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default DataAnalysis;
